import React from "react";
import { FeeType } from "~graphql/sdk";
import { Price } from "flicket-ui";
import { getTicketFeeProperties } from "./common.utils";

interface PriceWithFeeProps {
  price: number;
  ticketType: any;
  showFees: boolean;
}

const PriceWithFee = ({
  price,
  ticketType,
  showFees = false,
}: PriceWithFeeProps) => {
  if (!price) return <>Free</>;

  const { ticketFee, ticketFeeType, stadiumLevyFee } = getTicketFeeProperties(
    ticketType
  );

  if (!showFees || (ticketFee <= 0 && stadiumLevyFee <= 0)) {
    return <Price price={price} />;
  }

  const FeeComponent = (() => {
    const Component =
      ticketFeeType === FeeType.Percentage ? (
        <span>{`${ticketFee}%`}</span>
      ) : (
        <Price price={ticketFee + stadiumLevyFee} />
      );

    return <>{Component} Fees</>;
  })();

  return (
    <>
      <Price price={price} /> {"\u002B"} {FeeComponent}
    </>
  );
};

export default PriceWithFee;
